<div class="blog">

    {#if blogContent.hero}

    <div class="blog__hero tint tint--primary">
    
        <Post {...blogContent.hero} posts={[]} />
    
    </div>
    
    {/if}
    
    <div class="blog__posts">

        <SectionHeader>

            {#if blogContent.hero}

            <h1>{blogContent.hero.title}</h1>

            {:else}

            <h1>Blog</h1>

            {/if}

        </SectionHeader>
    
        <Posts posts={blogContent.posts} baseUrl="/blog" limit={limit} />
    
    </div>

</div>

<style>

    .blog {
        
    }

    :global(.blog__hero .grid) {
        flex-direction: column;
    }

    :global(.blog__hero .grid__item) {
        width: inherit;
    }

    .blog__posts {
        
    }

</style>

<script>
    // components
    import Posts from 'components/Posts.html'
    import Post from 'components/Post.html'
    
    // views
    import posts from 'posts'
    import SectionHeader from 'views/compounds/sectionheader'

    export default {
        components: {
            Posts,
            Post,
            SectionHeader
        },
        computed: {
            blogContent: ({ posts, id }) => {
                let hero = null
                let filteredPosts = [...posts]

                const foundPost = posts.find(post => post.id == id)

                if (foundPost) {
                    hero = foundPost
                    filteredPosts = foundPost.posts
                }

                return {
                    hero,
                    posts: filteredPosts
                }
            }
        },
        oncreate() {
            
        },
        data() {
            return {
                id: '',
                posts,
                limit: 0
            }
        }
    }
</script>